import OscdSclDialogs from './OscdSclDialogs.js';
import './OscdTextEditor-BttQVixB.js';
import './foundation.js';

customElements.define('oscd-scl-dialogs', OscdSclDialogs);

export { OscdSclDialogs };
//# sourceMappingURL=oscd-scl-dialogs.js.map
